import React from 'react'
import { useState } from 'react'
import { ShopHomePageResponse } from 'src/Libs/shop/models'
import { ShopMainSkeleton } from 'src/Libs/shop/components/Skeletons'
import { useEffectShopAccess, useShop } from 'src/Libs/shop/hooks'
import CategoryCard from './CategoryCard'
import { makeStyles } from 'tss-react/mui'
import { Box, Grid } from '@mui/material'
import { useTypedSelector } from 'src/State/RootReducer'
import StaticCategoryCard from './StaticCategoryCard'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import OrderHistory from 'src/Resources/Images/shop/OrderHistory.png'
import PromotionCodes from 'src/Resources/Images/shop/PromotionCodes.png'
import { VAD_CUSTOMER_GROUP_ID } from '../../consts'
import { useNavigate } from 'react-router-dom'

const useStyles = makeStyles()(theme => ({
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
}))

/*
 * The HomePageCard component is Showing all the shop categories and handling the logic for System Configure Category or Normal Category
 */
const HomePageCard: React.VFC = () => {
  const { getHomePageData } = useShop()
  const { t } = useCustomTranslation()
  const navigate = useNavigate()
  const { classes } = useStyles()
  const [cards, setCards] = useState<ShopHomePageResponse[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const selectedUserShopToken = useTypedSelector(state => state.shop.selectedUserData?.contextToken)
  const selectedUserCustomerGroupId = useTypedSelector(state => state.shop.selectedUserData?.customerGroupId)
  const customerGroupId = useTypedSelector(state => state.shop.customerGroupId)
  const isVadCustomerGroup = customerGroupId === VAD_CUSTOMER_GROUP_ID
  const selectedUserIsVadCustomerGroup = selectedUserCustomerGroupId === VAD_CUSTOMER_GROUP_ID
  const hasPromotionCodeAccess = isVadCustomerGroup || selectedUserIsVadCustomerGroup

  useEffectShopAccess(() => {
    getHomePageData()
      .then(result => setCards(result))
      .catch(error => console.log(error))
      .finally(() => setIsLoading(false))
  }, [selectedUserShopToken]) // eslint-disable-line

  if (isLoading) {
    return (
      <Box marginTop={3}>
        <ShopMainSkeleton shopSkeletonType="category" />
      </Box>
    )
  }

  return (
    <Box>
      <Grid className={classes.contentWrapper} container spacing={3} marginTop={1}>
        {cards.map(card => (
          <CategoryCard key={card.id} card={card} />
        ))}
        <StaticCategoryCard onClick={() => navigate('/shop/order-history')} title={t('shop.homepage.order-history')} image={OrderHistory} />
        {hasPromotionCodeAccess && (
          <StaticCategoryCard onClick={() => navigate('/shop/promotion-codes')} title={t('shop.homepage.promotion-codes')} image={PromotionCodes} />
        )}
      </Grid>
    </Box>
  )
}

export default HomePageCard
